@if (timezoneService.isVisible) {
  <div
    ngbDropdown
    #tzDropdown="ngbDropdown"
    class="d-flex"
    [placement]="headerResponsivenessOptions.hideTimezoneSwitch ? 'left-top' : 'bottom-right'"
    [container]="headerResponsivenessOptions.hideTimezoneSwitch ? 'body' : null"
    (mouseenter)="onMouseEnter(tzDropdown)"
    (mouseleave)="onMouseLeave(tzDropdown)"
    [matTooltip]="timezoneService.isDisabled ? (timezoneService.level === 'portfolio'? ('HEADER.TIMEZONE_LOCKED_PORTFOLIO' | translate): ('HEADER.TIMEZONE_LOCKED' | translate )): null"
    >
    <button 
      class="btn flex-row d-inline-flex align-items-center font-weight-bold text-primary font-size-normal medium" 
      ngbDropdownToggle
      style="border:0; outline:0;"
      [disabled]="timezoneService.isDisabled"
      [class.disabled]="timezoneService.isDisabled"
      (click)="onDropdownToggle($event)"
      >
      <ng-container>
        <i class="far fa-clock font-icons mr-2"></i>
        <span
          class="label-container font-weight-bold text-primary"
          [ngClass]="headerResponsivenessOptions.hideTimezoneSwitch ? 'font-size-small' : 'font-size-normal'">
          {{ timezoneService.selectedOption | noUnderscore }}
        </span>
      </ng-container>
        <i class="far ml-2 font-size-small"
          [ngClass]="{
            'fa-chevron-down': !headerResponsivenessOptions.hideTimezoneSwitch && !tzDropdown.isOpen(),
            'fa-chevron-up': !headerResponsivenessOptions.hideTimezoneSwitch && tzDropdown.isOpen(),
            'fa-chevron-right': headerResponsivenessOptions.hideTimezoneSwitch
          }">
      </i>
    </button>
    
      <div 
      ngbDropdownMenu 
      class="z-index-10000 w-100" 
      (mouseenter)="onMouseEnter(tzDropdown)"
      (mouseleave)="onMouseLeave(tzDropdown)"
      >
      @for (option of timezoneService.options; track option.label; let i = $index) {
        @if (!option.divider) {
          <button
            ngbDropdownItem
            data-testid="timezone-switch-change-button"
            class="font-weight-bold text-center font-size-small p-0 m-0 dropdown-item-hover"
            (click)="handleSelectedChanged(option)"
            >
            @if (!option.isSpecial) {
              <span [ngClass]="{'selected-option': timezoneService.selectedOption === option?.value}" class="ellipsis p-1 px-3 d-block opacity-dark-9 font-weight-600">
                {{option.label | translate | noUnderscore}}
              </span>
            } @else {
              <span [ngClass]="{'selected-option': timezoneService.selectedOption === option?.value}" class="ellipsis p-1 px-3 d-block opacity-dark-9 font-weight-600">
                {{option.label | translate | noUnderscore}}<br>
                <span [ngClass]="{'gray-text': timezoneService.selectedOption !== option?.value, 'white-text': timezoneService.selectedOption === option?.value}">
                  {{option.value | noUnderscore}}
                </span>
              </span>
            }
          </button>
        } @else {
          <div class="dropdown-divider"></div>
        }
      }
    </div>
  </div>
}